import React, { useRef, useState } from "react";
import { Col, Container, Row, Tooltip } from "react-bootstrap";
import L from "leaflet";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";
import { tr } from "date-fns/locale";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

function BranchesLoc({ setLatLong, value }) {
  const mapRef = useRef();
  const center = [35.67737855391475, 51.392628882873055];
  const [coordinates, setCoordinates] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [centerMarker, setCenterMarker] = useState({
    latlng: center,
  });
  const ZOOM_LEVEL = 9;
  const MAP_ATTRIBUTE =
    '&copy; <a href="https://www.NanoPardazan.com/copyright">NPT</a> contributors';
  const MAP_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

  console.log(centerMarker.latlng);
  const lockMove = useRef();
  const handleMapMove = (e) => {
    const center = mapRef.current.getCenter();
console.log(center, 'center')
    setCenterMarker({ latlng: center });
    setLatLong(centerMarker.latlng)
    // if (!lockMove.current) {
    // } else {
    //   console.log({ ...mapRef.current });
    //   mapRef.current.setView(centerMarker.latlng);
    // }
    // console.log(e);
  };
  // const handleZoomStart = (e) => {
  //   lockMove.current = true;
  // };
  // const handleZoomEnd = (e) => {
  //   if (lockMove.current) {
  //     mapRef.current.setView(centerMarker.latlng);
  //     lockMove.current = false;
  //   }
  //   // mapRef.current.setCenter(centerMarker.latlng);
  // };
  // const hanlde
  const MapEventsHandler = () => {
    const map = useMapEvents({
      move: handleMapMove,
      // zoomstart: handleZoomStart,
      // zoomend: handleZoomEnd,
      zoom: handleMapMove,
    });
    return null;
  };
  const handleZoom = () => {
    console.log(mapRef.current);
  };
  const zoomOrigin = [100, 100];
  console.log(value)
  return (
    <Container>
      <Row>
        <Col className=""></Col>
      </Row>

      <Row className="profile-row h-auto key-req" style={{ marginTop: "1px" }}>
        <Col className="box profile-col">
          <div>
            <MapContainer
              center={center}
              zoom={ZOOM_LEVEL}
              // scrollWheelZoom={true}
              ref={mapRef}
              eventHandlers={{ WheelEvent: (e) => console.log(e) }}
              zoomControl={true} // Disable default zoom control
              zoomSnap={0} // Disable snapping for smoother zooming
              zoomDelta={0.5} // Set zoom delta
              zoomAnimation={false}
              zoomOrigin={centerMarker.latlng}
              keepBuffer={true}
            >
              <TileLayer attribution={MAP_ATTRIBUTE} url={MAP_URL} />

              <Marker
                draggable={false}
                // eventHandlers={{
                //   dragend: (e) => {
                //     setLatLong(e.target.getLatLng());
                //   },
                // }}
                position={ centerMarker.latlng}
              >
                <Popup>فروشگاه</Popup>
              </Marker>

              <MapEventsHandler handleMapMove={(e) => console.log(e)} />
            </MapContainer>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
export default BranchesLoc;
